"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _addNewWidget = _interopRequireDefault(require("./add-new-widget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _addNewWidget["default"];
exports["default"] = _default;